import {getHistoryMessagesFromSQL, processMessage} from "@/views/CustomerMessageManage/handler/MessageHandler";
import {HeartBeatMessage} from "@/views/CustomerMessageManage/messages/request/HeartBeatMessage";
import {Message} from "element-ui";

const HEARTBEAT_INTERVAL = 30000

let that = undefined
let socket = undefined
let heartbeat = undefined
const heartBeatMessage = new HeartBeatMessage()

const sendMsg = function (message){
    if (socket && socket.readyState===1){
        socket.send(JSON.stringify(message))
        return true
    }
    return false
}

const clearHeartbeat = function () {
    if (heartbeat) {
        clearInterval(heartbeat)
        heartbeat = undefined
    }
}

const sendHeartbeat = function () {
    sendMsg(heartBeatMessage)
}

const startHeartbeat = function () {
    clearHeartbeat()
    sendHeartbeat()
    heartbeat = setInterval(sendHeartbeat, HEARTBEAT_INTERVAL)
}

const onOpen = function (){
    if (!that) return
    that.setOnlineDisabled(false)
    that.setOnlineState(true)
    console.log('WebSocket 已连接')
    startHeartbeat()
}

const onMessage = function (e){
    let message = e.data
    processMessage(JSON.parse(message), that)
}

const onClose = function (){
    console.log("WebSocket 连接已关闭")
    clearHeartbeat()
    if (that) {
        that.setOnlineDisabled(false)
        that.setOnlineState(false)
        that.setSocket(undefined)
    }
    socket = undefined
}

const onError = function (e){
    console.error("WebSocket 连接异常", e)
    clearHeartbeat()
    if (that) {
        that.setOnlineDisabled(false)
        that.setOnlineState(false)
        that.setSocket(undefined)
    }
    Message({message:'连接异常', type:"error"})
    socket = undefined
}

const offline = function (){
    clearHeartbeat()
    if (socket) {
        try {
            if (socket.readyState === 1 || socket.readyState === 0) {
                socket.close()
            }
        } catch (e) {
            console.error('关闭 WebSocket 失败', e)
        }
        socket = undefined
    }
    if (that) {
        that.setOnlineState(false)
        that.setSocket(undefined)
    }
}

const online = function (_that, _socket) {
    if (_that) that = _that
    if (_socket) socket = _socket
    if (!window.WebSocket) {
        alert("浏览器不支持websocket协议...");
        return
    }

    const token = localStorage.getItem('admin_token')
    if (!token) return

    if (socket && socket.readyState === 1) {
        if (!heartbeat) {
            startHeartbeat()
        }
        that.setOnlineState(true)
        return
    }

    if (socket && socket.readyState === 0) {
        return
    }

    console.log('建立 WebSocket 连接...')

    getHistoryMessagesFromSQL(token, that)

    socket = new WebSocket(process.env.VUE_APP_WEB_SOCKET_BASE_URL + '?access_token=' + token)
    socket.onopen = onOpen
    socket.onmessage = onMessage
    socket.onclose = onClose
    socket.onerror = onError
    that.setSocket(socket)
}

export {
    sendMsg,
    offline,
    online
}
